import React from 'react';
import { TextField, InputLabel } from '@mui/material';

/**
 * ラベル付きテキストフィールドコンポーネント
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.label - ラベルのテキスト
 * @param {string} props.id - フィールドのID
 * @param {string} props.name - フィールドの名前
 * @param {string} props.type - 入力タイプ（text, password, email等）
 * @param {string} props.placeholder - プレースホルダーテキスト
 * @param {string} props.autoComplete - 自動補完の設定
 * @param {boolean} props.autoFocus - 自動フォーカスの設定
 * @param {Object} props.register - react-hook-formのregister関数
 * @param {Object} props.error - エラーオブジェクト
 * @param {string} props.helperText - ヘルパーテキスト
 * @param {string} props.variant - TextFieldのバリアント
 * @param {Object} props.sx - 追加のスタイル
 * @returns {JSX.Element} ラベル付きテキストフィールド
 */
const LabeledTextField = ({
  label,
  id,
  name,
  type = 'text',
  placeholder,
  autoComplete,
  autoFocus = false,
  register,
  error,
  helperText,
  variant = 'outlined',
  sx = {},
  ...props
}) => {
  return (
    <>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <TextField
        margin="none"
        fullWidth
        id={id}
        name={name}
        type={type}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        placeholder={placeholder}
        {...register(name)}
        error={!!error}
        helperText={error?.message || helperText}
        variant={variant}
        sx={sx}
        {...props}
      />
    </>
  );
};

export default LabeledTextField;
